export const successMessageForgotPassword = 'Email sent successfully.';
export const messageNoUsername = 'No Name Provided';
export const messageRoleDefaultInfo =
  'Whether to assign this role by default when a user registers. Only one role can be the default.';
export const messageRoleAnonymousInfo =
  'Whether this role will be assigned when Variant is used anonymously. Only one role can be assigned to anonymous usage.';
export const messageRoleCurrentDefault =
  'This role is designated as the default. If you want to change the default, update another role.';
export const messageRoleCurrentAnonymous = 'This role is designated as the role assigned when a user is not logged in.';
export const messageRoleAnonymousDisabled = 'Anonymous access is currently disabled in settings.';
export const messageRoleAdminProductsSpecifications =
  'Roles with the "Product Manager" or "Settings" page assigned have access to all products.';
export const messageRoleAnonymousPages = 'Anonymous users access to "Pages" cannot be modified.';
